// extracted by mini-css-extract-plugin
export default {"tooltip":"oP-z","arrow":"pP-z"};